import { ContractorType } from './ContractorType'
import { EditPersons } from './EditPersons'

export const PayForm = () => {
  return (
    <>
      <ContractorType />
      <EditPersons />
    </>
  )
}
